import React, { forwardRef, useImperativeHandle } from 'react';
import { Selector, useLang } from '@manulife/mux';
import { Controller, useFormContext } from 'react-hook-form';
import LABELS from '../../../assets/labels';

const IrSex = forwardRef(({ detailFor }, sexRef) => {
    const selectedLang = useLang();
    const { control } = useFormContext(); // retrieve all hook methods
    const name = `${detailFor}.irSex` ;
    const focusSexField = () => {
        // focus on first button 
        document.getElementById(`${name}-0`)?.focus();
    };

    useImperativeHandle(sexRef, () => ({
        focus: focusSexField
    }));

    return (
        <Controller
            control={control}
            name={name}
            rules={{
                required: LABELS.errors.required.irSex[detailFor][selectedLang]
            }}
            render={({
                field: { onChange, onBlur, value, name },
                fieldState: { error },
            }) => (
                <Selector
                    id={name}
                    label={LABELS.question4[selectedLang][detailFor].question}
                    aria-label={LABELS.question4[selectedLang][detailFor].ariaLabel}
                    aria-required={true}
                    values={LABELS.question4[selectedLang].options}
                    selected={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    errors={error && [error.message]}
                    callouts={false}
                    customStyle={{
                        rootStyle: {
                            width: "100%",
                        },
                    }}
                />
            )}
        />
    );
});

export default IrSex;